export interface Colors {
    onlyPositive: {
        max: string;
        min: string;
    };
    onlyNegative: {
        max: string;
        min: string;
    };
    both: {
        max: string;
        min: string;
    };
}

// Pick the color based on the min and max residual values
export const pickColors = ({
    minValue,
    maxValue,
    colors,
}: {
    minValue: number | undefined;
    maxValue: number | undefined;
    colors: Colors;
}) => {
    if (minValue && minValue > 0) {
        return {
            onlyPositive: true,
            onlyNegative: false,
            max: colors.onlyPositive.max,
            min: colors.onlyPositive.min,
        };
    }
    if (maxValue && maxValue < 0) {
        return {
            onlyPositive: false,
            onlyNegative: true,
            max: colors.onlyNegative.max,
            min: colors.onlyNegative.min,
        };
    }
    return {
        onlyPositive: false,
        onlyNegative: false,
        max: colors.both.max,
        min: colors.both.min,
    };
};
